import { queryOptions } from '@tanstack/react-query'

import { w } from '@/lib/api'
import { API_ENDPOINTS } from '@/lib/constants/api'

import { type ResClientPortalEoirPublicCaseInformationQuery } from './types'

export interface ClientPortalEoirPublicCaseInformation {
  caseId: number
  companyId?: number
}

export const clientPortalEoirPublicCaseInformationQuery = ({
  caseId,
  companyId,
}: ClientPortalEoirPublicCaseInformation) =>
  queryOptions<ResClientPortalEoirPublicCaseInformationQuery>({
    queryKey: [API_ENDPOINTS['case-dashboard'].eoir.index, caseId, companyId],
    queryFn: () =>
      w
        .url(`${API_ENDPOINTS['case-dashboard'].eoir.index}/${caseId}`)
        .query({
          companyId,
          flag: 3,
        })
        .get()
        .json(),
    enabled: !!caseId,
  })
